export const dataAcareacoesReducer = (state, action) => {
  state.dataAcareacoes.data = action.payload?.items ?? [];
  state.dataAcareacoes.isLoading = false;
  state.dataAcareacoes.requestGetParams = {
    ...action.meta.arg,
  };

  state.dataAcareacoes.pagination = {
    page: action.meta.arg.pagina,
    rowsPerPage: action.meta.arg.itensPorPagina,
    totalPages: action.payload.totalPaginas,
    totalItems: action.payload.totalRegistros,
  };
};
